import { getPoiLogoUrl } from '@/helpers/common/poiAttribution.helper';

import './brandSection.scss';

import type { AudienceInsightsBrand } from '../AudienceInsights';

/** A card: a brand, or a POI category with its own icon instead of a logo. */
type BrandSectionItem = AudienceInsightsBrand & { icon?: string };

type Props = {
  title: string;
  brands: BrandSectionItem[];
};

/** Icon of a brand with no logo. */
const FALLBACK_ICON = 'fa-kit-duotone fa-poi-inventory';

export function BrandSection({ title, brands }: Props) {
  return (
    <div className="brandSection">
      <h4 className="brandSection__title">{title}</h4>
      <ul className="brandSection__list">
        {brands.map(brand => {
          const logoUrl = getPoiLogoUrl(brand.logoS3 ?? undefined);
          return (
            <li className="brandSection__item" key={brand.name}>
              <div className="brandSection__card">
                {logoUrl ? (
                  <img alt={brand.name} className="brandSection__logo" src={logoUrl} />
                ) : (
                  <i className={`${brand.icon ?? FALLBACK_ICON} brandSection__fallbackIcon`} />
                )}
              </div>
              <span className="brandSection__name">{brand.name}</span>
            </li>
          );
        })}
      </ul>
    </div>
  );
}
